const OtherFAQ = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      strokeWidth={1.5}
      d="M12.6831 8.84065L13.3138 9.24649L12.6831 8.84065ZM8.25 7.75986C8.25 8.17407 8.58579 8.50986 9 8.50986C9.41421 8.50986 9.75 8.17407 9.75 7.75986H8.25ZM10.25 12.2599C10.25 12.6741 10.5858 13.0099 11 13.0099C11.4142 13.0099 11.75 12.6741 11.75 12.2599H10.25ZM11.75 14.7599C11.75 14.3456 11.4142 14.0099 11 14.0099C10.5858 14.0099 10.25 14.3456 10.25 14.7599H11.75ZM10.25 15.7599C10.25 16.1741 10.5858 16.5099 11 16.5099C11.4142 16.5099 11.75 16.1741 11.75 15.7599H10.25ZM20.25 10.7599C20.25 15.8685 16.1086 20.0099 11 20.0099V21.5099C16.9371 21.5099 21.75 16.6969 21.75 10.7599H20.25ZM11 20.0099C5.89137 20.0099 1.75 15.8685 1.75 10.7599H0.25C0.25 16.6969 5.06294 21.5099 11 21.5099V20.0099ZM1.75 10.7599C1.75 5.65122 5.89137 1.50986 11 1.50986V0.00985718C5.06294 0.00985718 0.25 4.8228 0.25 10.7599H1.75ZM11 1.50986C16.1086 1.50986 20.25 5.65122 20.25 10.7599H21.75C21.75 4.8228 16.9371 0.00985718 11 0.00985718V1.50986ZM12.25 7.75986C12.25 8.00982 12.1774 8.24054 12.0524 8.43481L13.3138 9.24649C13.5899 8.81743 13.75 8.30619 13.75 7.75986H12.25ZM9.75 7.75986C9.75 7.0695 10.3096 6.50986 11 6.50986V5.00986C9.48122 5.00986 8.25 6.24107 8.25 7.75986H9.75ZM11 6.50986C11.6904 6.50986 12.25 7.0695 12.25 7.75986H13.75C13.75 6.24107 12.5188 5.00986 11 5.00986V6.50986ZM10.25 11.7599V12.2599H11.75V11.7599H10.25ZM12.0524 8.43481C11.9265 8.63051 11.7688 8.83299 11.5836 9.06314C11.4063 9.28355 11.1979 9.53621 11.011 9.79311C10.6424 10.2996 10.25 10.9606 10.25 11.7599H11.75C11.75 11.4546 11.9003 11.1204 12.2239 10.6756C12.383 10.4569 12.558 10.2449 12.7523 10.0035C12.9387 9.7718 13.1409 9.51523 13.3138 9.24649L12.0524 8.43481ZM10.25 14.7599V15.7599H11.75V14.7599H10.25Z"
      fill="#1C1C2C"
    />
  </svg>
);

const DragHandle = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 1.39548H17.5M1.5 6.60454H17.5"
      stroke="#919299"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UpperRightArrow = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="-5 -5 25 24"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.980469 11.5775L11.3043 1.25369M11.3043 1.25369V11.1646M11.3043 1.25369H1.39342"
      stroke="#FDFEFE"
      strokeWidth="1.58828"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconDotsBlog = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse cx="16.0715" cy="10.5" rx="1.21212" ry="1.25" fill="#1C1C2C" />
    <ellipse cx="16.0715" cy="15.5" rx="1.21212" ry="1.25" fill="#1C1C2C" />
    <ellipse cx="16.0715" cy="20.5" rx="1.21212" ry="1.25" fill="#1C1C2C" />
  </svg>
);

const IconBlog = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 6a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-10a4 4 0 0 1-4-4z"
      stroke="#FDFEFE"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path d="M8.5 17h4m-4-5h8m-8-5h8" stroke="#FDFEFE" strokeWidth={1.5} strokeLinecap="round" />
  </svg>
);

export { OtherFAQ, DragHandle, UpperRightArrow, IconDotsBlog, IconBlog };
